/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable */
import { AlipayMiniOptionsType, uploadFileOptionsTypes } from './types';

const HBridge = import('@hb/hbridge');
const HBridgeCore = import('@hb/bridge-core');
/** *
 * 在小程序环境中的拍照方法
 *拍照或从手机相册中选择图片
 * @param options
 * @param {number} [options.count=1] - 最大可选照片数。
 * @param {string[]} [options.sizeType=['original', 'compressed']] - original: 原图; compressed: 压缩图
 * @param {string[]} [options.sourceType=[‘camera’,‘album’]] - 相册选取或者拍照
 * @param {Function} [options.success] - 调用成功的回调函数
 * @param {Function} [options.fail] - 调用失败的回调函数
 * @param {Function} [options.complete] - 调用结束的回调函数（调用成功、失败都会执行）
 * @return {Promise<string[]>}
 * @see {@link https://opendocs.alipay.com/mini/api/media/image/my.chooseimage?pathHash=3770863e}
 * */

export const alipayHitchTakePhoto = async (options: AlipayMiniOptionsType): Promise<any> => (await HBridge).Native.callNative({
  method: 'chooseImage',
  params: options,
  timeout: false
});

/**
 * 上传图片
 * @param {string} filePath
 * @param {object} [options] - 需要补充的formData字段 { image: 1, type: 5 } {https://hellobike.yuque.com/gqiz6x/amhg34/fegotc}
 * @return {Promise<any>}
 * @see {@link https://opendocs.alipay.com/mini/api/kmq4hc}
 */
export const uploadFile = async (
  filePath: string, options: uploadFileOptionsTypes,
): Promise<any> => (await HBridgeCore).alipayCallNative({
  classMap: 'Native', // 哈啰出行小程序的classMap默认值为Native
  command: 'uploadFile',
  dataArray: [filePath, options],
});

/**
 * 支付宝小程序中打开新页面，第二个参数表示不携带用户信息
 */
export const aliOpenThirdPageWithoutInfo = async (
  url: string
  ): Promise<any> => (await HBridgeCore).alipayCallNative({
  classMap: 'Native',
  command: 'goOperationUrlV2',
  dataArray: [url, true],
});
